module.exports = __webpack_public_path__ + "img/65d1b47.png";